export default __webpack_public_path__ + "static/hero-bg-8b1fc38a2eeab18073b015f370c27e1b.webp";